module.exports = __webpack_public_path__ + "7cb1ffd27760f13c6cb09764d699a2b2.pdf";